const wowApp = require('angular').module('wowApp.digitalpay');

const { giftCardComponentDefinition } = require('./gift-card.component');
const { giftCardAddPaymentComponentDefinition } = require('./gift-card-add-payment.component');

wowApp.component('wowGiftCard', giftCardComponentDefinition);
wowApp.component('wowGiftCardAddPayment', giftCardAddPaymentComponentDefinition);



// WEBPACK FOOTER //
// ./src/digitalpay/giftcard/index.js